<template>
    <div>
        <PageBanner :pageTitle="$t('sidebar_inonlays_title_five')" />

        <OnLaysBenefits/>
    </div>
</template>

<script>
import OnLaysBenefits from '../blog-details/OnLaysBenefits.vue'
import PageBanner from '../Common/PageBanner'

export default {
    components: {
       PageBanner,
        OnLaysBenefits ,
    }
}
</script>